import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const apply = {
  main: () => import('$routed/Apply/Main.vue'),
}

const _public = {
  main: () => import('$routed/Public/Main.vue'),
  giftCard: () => import('$routed/Public/GiftCard.vue')
}

const admin = {
  main: () => import('$admin/Main.vue'),
  classesEditor: () => import('$admin/ClassesEditor.vue'),
  applicants: () => import('$admin/Applicants.vue'),
  students: () => import('$admin/Students.vue'),
  guardians: () => import('$admin/Guardians.vue'),
  courses: () => import('$admin/Courses.vue'),
  invoices: () => import('$admin/Invoices.vue'),
  discountCodes: () => import('$admin/DiscountCodes.vue'),
  giftCards: () => import('$admin/GiftCards.vue'),
}

const guardian = {
  main: () => import('$routed/Guardian/Main.vue'),
  dashboard: () => import('$routed/Guardian/GuardianDashboard.vue'),
  signUp: () => import('$routed/Guardian/GuardianSignUp.vue')
}

const account ={
  resetPassword: () => import('$routed/Account/ResetPassword.vue')
}

const shared = {
  student: () => import('$routed/Shared/Student.vue'),
}


// const authorizeEntry = (options) => {
//   const main = require('../src/main')
//   const auth = main.auth
//   if (!auth.currentUser) return options.next({name: 'PublicHome', query: {redirect: options.to.fullPath}})
//   options.next()
// }

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/apply',
      component: apply.main,
      name: 'ApplyMain',
      // beforeEnter: (to, from, next) =>{
      //   window.location.assign('https://virtual.southbendcodeschool.com')
      // }
    },
    {
      path: '/',
      component: _public.main,
      name: 'Home',
    },
    {
      path: '/gift-card',
      component: _public.giftCard,
      name: 'GiftCard'
    },
    {
      path: '/admin',
      component: admin.main,
      children: [
        {
          path: 'students',
          component: admin.students,
          name: 'AdminMain',
        },
        {
          path: 'guardians',
          component: admin.guardians,
          name: 'AdminGuardians',
        },
        {
          path: 'applicants',
          component: admin.applicants,
          name: 'AdminApplicants',
        },
        {
          path: 'classes-editor',
          component: admin.classesEditor,
          name: 'AdminClassesEditor',
        },
        {
          path: 'students/:studentId',
          component: shared.student,
          name: 'AdminStudentView',
        },
        {
          path: 'courses',
          component: admin.courses,
          name: 'AdminCourses',
        },
        {
          path: 'invoices',
          component: admin.invoices,
          name: 'AdminInvoices'
        },
        {
          path: 'discount-codes',
          component: admin.discountCodes,
          name: 'AdminDiscountCodes',
        },
        {
          path: 'gift-cards',
          component: admin.giftCards,
          name: 'AdminGiftCards',
        },
      ],
      meta: {
        roles: ['ADMIN'],
      },
    },
    {
      path: '/guardian',
      component: guardian.main,
      name: 'GuardianMain',
      children: [
        {
          path: '/',
          component: guardian.dashboard,
          name: 'GuardianDashboard',
        },
        {
          path: '/guardian/sign-up',
          component: guardian.signUp,
          name: 'GuardianSignUp',
          props: true,
        },
      ],
      meta: {
        roles: ['GUARDIAN'],
      },
    },
    {
      path: '/account/reset-password',
      component: account.resetPassword,
      name: 'ResetPassword',
    },
    {
      path: '*',
      beforeEnter (to, from, next) {
        next({name: 'ApplyMain'})
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // /* eslint-disable */
  // return next()
  
  const roles = to.meta.roles
  if (!roles) return next()
  
  const main = require('./main')
  const getThat = () => new Promise(resolve => {
    try {
      const that = main.ThisVue
      resolve(that)
    } catch (e) {resolve()}
  })

  const interval = setInterval(async () => {
    const that = await getThat()
    if (that) clearInterval(interval)

    let search = location.search
    if (search) {
      search = search.substring(1) // remove that ?
      const searchArr = search.split('&')
      const searchObj = searchArr.reduce((obj, current, idx, arr) => {
        const [field, value] = current.split('=')
        obj[field] = value
        return obj
      }, {})

      if (searchObj.customToken) {
        await that.$auth.signInWithCustomToken(searchObj.customToken)
        return next()
      }
    }

    if (that.$auth.currentUser) {
      const user = that.$store.state.user
      for (let type in user.user_type) {
        if (roles.includes(type)) {
          that.$modals.hide('login')
          return next()
        }
      }
    }

    next({name: 'ApplyMain'})
    that.$modals.show({name: 'login'})

  }, 1)
})

export default router